export function time_string(time_ms) {
    let time = Math.floor(time_ms / 1000);
    if (time < 60)
        return time + " second(s)";
    time = Math.floor(time / 60);
    if (time < 60)
        return time + " minute(s)";
    time = Math.floor(time / 60);
    if (time < 24)
        return time + " hour(s)";
    time = Math.floor(time / 24);
    if (time < 30)
        return time + " day(s)";
    time = Math.floor(time / 30);
    if (time < 12)
        return time + " month(s)";
    time = Math.floor(time / 12);
    return time + " year(s)";
}